import React, { createContext, useState, useContext, useEffect } from 'react';

const DriverContext = createContext();

export const DriverProvider = ({ children }) => {
  const [isDriver, setIsDriver] = useState(false);
  const [driverEmail, setDriverEmail] = useState('');

  // Load driver state from localStorage on initial load
  useEffect(() => {
    const storedEmail = localStorage.getItem('driverEmail');
    const storedToken = localStorage.getItem('driverToken');
    
    if (storedEmail && storedToken) {
      setIsDriver(true);
      setDriverEmail(storedEmail);
    }
  }, []);

  const updateDriverStatus = (status, email = '') => {
    setIsDriver(status);
    setDriverEmail(email);
    
    if (status && email) {
      localStorage.setItem('driverEmail', email);
    } else {
      localStorage.removeItem('driverEmail');
      localStorage.removeItem('driverToken');
    }
    
    // Dispatch event for other components that might be listening
    window.dispatchEvent(new CustomEvent('driverStatusChanged', {
      detail: { email, status: status ? 'logged_in' : 'logged_out' }
    }));
  };

  return (
    <DriverContext.Provider value={{ isDriver, driverEmail, updateDriverStatus }}>
      {children}
    </DriverContext.Provider>
  );
};

export const useDriver = () => {
  const context = useContext(DriverContext);
  if (!context) {
    throw new Error('useDriver must be used within a DriverProvider');
  }
  return context;
};
